/**
 * Test ID utilities for Alert component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Alert container
 * @param identifier - Alert identifier (e.g., 'error', 'success', 'warning')
 * @returns Test ID string
 */
export const setAlertTestId = (identifier: string): string =>
  generateTestId("Alert", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AlertTitle
 * @param alertIdentifier - Parent alert identifier
 * @returns Test ID string
 */
export const setAlertTitleTestId = (alertIdentifier: string): string =>
  generateTestId(
    "AlertTitle",
    alertIdentifier.replace(/\s+/g, "-").toLowerCase(),
  );

/**
 * Generate test ID for AlertDescription
 * @param alertIdentifier - Parent alert identifier
 * @returns Test ID string
 */
export const setAlertDescriptionTestId = (alertIdentifier: string): string =>
  generateTestId(
    "AlertDescription",
    alertIdentifier.replace(/\s+/g, "-").toLowerCase(),
  );
